import { render } from "./WebList.vue?vue&type=template&id=21c57524&scoped=true"
import script from "./WebList.vue?vue&type=script&lang=js"
export * from "./WebList.vue?vue&type=script&lang=js"

import "./WebList.vue?vue&type=style&index=0&id=21c57524&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c57524"]])

export default __exports__